import { SMVariantDTO, SteelSMTypeDTO, SteelSQTypeDTO } from '~/api/webservice';
import { ISOPROProduct, SteelTypeProductDto } from '~/models';

export abstract class ISOPROSteelType extends ISOPROProduct {
  declare readonly height: SteelSMTypeDTO["height"];
  declare readonly capacity: SteelTypeProductDto["capacity"];
  declare readonly fireProtectionType: SteelTypeProductDto["fireProtectionType"];
  declare readonly hasFireProtection: boolean;
  declare readonly length: number;

  declare readonly properties: {
    dimensions: ISOPROProduct["properties"]["dimensions"];
    construction: {
      thrustBearings: ISOPROProduct["properties"]["construction"]["thrustBearings"] & {
        numberOfThrustShearNegBearing: SteelTypeProductDto["numberOfThrustShearNegBearing"];
        numberOfThrustShearPosBearing: SteelTypeProductDto["numberOfThrustShearPosBearing"];
        dimensionOfThrustShearPosBearing: SteelTypeProductDto["dimensionOfThrustShearPosBearing"];
        kindOfThrustBearing: SteelTypeProductDto["kindOfThrustBearing"];
      };
      tensionRods: {
        number: SteelTypeProductDto["numberOfTensionRods"];
      };
    };
  }

  constructor(data: SteelTypeProductDto) {
    super(data);
    this.height = data.height;
    this.capacity = data.capacity;
    this.hasFireProtection = false;
    this.length = data.length;

    this.properties = {
      ...this.properties,
      construction: {
        ...this.properties.construction,
        thrustBearings: {
          ...this.properties.construction.thrustBearings,
          numberOfThrustShearNegBearing: data.numberOfThrustShearNegBearing,
          numberOfThrustShearPosBearing: data.numberOfThrustShearPosBearing,
          dimensionOfThrustShearPosBearing: data.dimensionOfThrustShearPosBearing,
          kindOfThrustBearing: data.kindOfThrustBearing,
        },
        tensionRods: {
          number: data.numberOfTensionRods,
        }
      }
    }
  }
}

export class ISOPROProductSQType extends ISOPROProduct {
  declare readonly type: SteelSQTypeDTO["type"];

  constructor (data: SteelSQTypeDTO) {
    super(data);
    this.type = data.type;
  }

  // getOneWithoutFireProtection (): ISOPROProduct | null {
    //   if (this.hasFireProtection) return null;
    //   const rowKey = `${this.rowKey} ${SQTypeDTOFireProtectionTypeEnum.Rei120}`;
    //   return useProductsStore().productsMap.get(rowKey) || null;
    // }
}

export class ISOPROProductSMType extends ISOPROProduct {
  declare readonly type: SteelSMTypeDTO["type"];
  protected readonly _shearForceLoadBearingCapacity: [number];
  readonly shearForceLoadBearingCapacityCode: SteelSMTypeDTO['shearForceLoadBearingCapacityCode'];

  constructor (data: SteelSMTypeDTO) {
    super(data);
    this.type = data.type;
    this.shearForceLoadBearingCapacityCode = data.shearForceLoadBearingCapacityCode;

    if (data.shearForceLoadBearingCapacityCode) {
      const [_, ...values] = this.shearForceLoadBearingCapacityCode.split('Q');
      this._shearForceLoadBearingCapacity = [+values[0]];
    } else {
      this._shearForceLoadBearingCapacity = [0];
    }
  }

  // getOneWithoutFireProtection (): ISOPROProduct | null {
  //   if (this.hasFireProtection) return null;
  //   const rowKey = `${this.rowKey} ${SMTypeDTOFireProtectionTypeEnum.Rei120}`;
  //   return useProductsStore().productsMap.get(rowKey) || null;
  // }
}

export class ISOPROProductSMVariantType extends ISOPROProductSMType {
  declare readonly variant: SMVariantDTO["variant"];
  declare readonly minimumWallThickness: SMVariantDTO["minimumWallThickness"];

  constructor (data: SMVariantDTO) {
    super(data);
    this.variant = data.variant;
    this.minimumWallThickness = data.minimumWallThickness;
  }
}
